import React from "react"

import {NoTransactions} from "./NoTransactions"
import {List} from "./List"

import {Transaction} from "@indebted/api"

function Transactions({transactions}: {transactions: Transaction[]}) {
	if (transactions.length === 0) {
		return <NoTransactions>No Transactions</NoTransactions>
	}
	return <List Transactions={transactions} />
}

export {Transactions}
